module.exports = __webpack_public_path__ + "img/40_38_020_100.473867a1.jpg";